import {
    Center,
    Spinner,
    Flex,
    Box,
    Heading,
    Tabs,
    TabList,
    TabPanels,
    Tab,
    TabPanel,
    Stack,
    Skeleton,
    Container,
    Text,
    IconButton,
    Divider,
} from '@chakra-ui/react';

import { PaperPlane } from '../../components/icons/icons';
import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import Tour from 'reactour';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as wActions from '../../redux/wallet/actionCreators';
import * as abActions from '../../redux/addressbook/actionCreators';
import { guideCompleted } from '../../redux/common/actionCreators';
import PageBody from '../../components/pageBody/pageBody';
import LiveBalance from '../../components/liveBalance/liveBalance';
import WalletAddress from '../../components/walletAddress/walletAddress';
import { AvailableNetworks } from '../../redux/common/types';
import { infuraProviderByNetwork } from '../../imports/utils';
import Footer from '../../components/footer/footer';
import AddressList from '../../components/addressList/addressList';

type WalletProps = {
    wallet?: any;
    loading: boolean;
    walletActions?: any;
    addressBookActions?: any;
    addresses: Array<string>;
    commonActions?: any;
    tourCompleted: boolean;
    network: AvailableNetworks;
};

const steps = [
    {
        selector: '#balance',
        content:
            'Questo è il tuo saldo. Rappresenta la quantità di Ether disponibili nel tuo Wallet',
    },
    {
        selector: '#address',
        content:
            "L'indirizzo del tuo Wallet rappresenta il suo identificativo su blockchain. E' un po' come un IBAN, ma con i superpoteri",
    },
    {
        selector: '#registered-addresses',
        content:
            "Qui puoi trovare l'elenco degli Address dei Wallet generati tramite BIS HUB",
    },
    {
        selector: '#send',
        content: 'Clicca qui per inviare Ether a un altro Wallet',
    },
    {
        selector: '#twitter',
        content:
            'Clicca qui per comunicare al mondo intero che hai finalmente un Wallet su Ethereum',
    },
    {
        selector: '#etherscan',
        content:
            'Clicca qui per vedere lo stato del tuo Wallet su Etherscan, uno dei principali blockchain explorer su Ethereum',
    },
    {
        selector: '#menu-button-network',
        content:
            'Clicca qui per scegliere tra la rete di test (Ropsten) e la rete principale (Mainnet)',
    },
];

const Wallet = (props: WalletProps) => {
    const history = useHistory();
    const wallet = props.wallet;
    const loading = props.loading;
    const [isTourOpen, setIsTourOpen] = useState<boolean>(false);

    useEffect(() => {
        if (!wallet) {
            history.replace('/wallet/create');
        }
    }, [wallet]);

    useEffect(() => {
        if (!props.tourCompleted) {
            setTimeout(() => setIsTourOpen(true), 1000);
        }

        // props?.addressBookActions?.addressBookFetch();
        props?.addressBookActions?.addressBookSubscribe();
    }, []);

    const handleTourClose = useCallback(() => {
        setIsTourOpen(false);
        props.commonActions?.guideCompleted('wallet');
    }, [isTourOpen]);

    if (loading) {
        return (
            <PageBody>
                <Center>
                    <Spinner color='blue.500' size='xl' />
                </Center>
            </PageBody>
        );
    }

    return (
        <Container maxW='6xl' h='calc(100vh - 80px)'>
            <Flex direction='column' h='100%'>
                <Flex flex='1' justifyContent='center' direction='column'>
                    <Flex
                        flex='1'
                        justifyContent='center'
                        alignItems='center'
                        id='balance'
                    >
                        {wallet && (
                            <>
                                <Heading size='md' pl={4} w='80px' />
                                <Heading size='3xl'>
                                    {props.network === 'ropsten' && (
                                        <LiveBalance
                                            walletAddress={wallet.address}
                                            provider={infuraProviderByNetwork(
                                                'ropsten',
                                            )}
                                        />
                                    )}
                                    {props.network === 'mainnet' && (
                                        <LiveBalance
                                            walletAddress={wallet.address}
                                            provider={infuraProviderByNetwork(
                                                'mainnet',
                                            )}
                                        />
                                    )}
                                </Heading>
                                <Heading size='md' pl={4} w='80px'>
                                    ETH
                                </Heading>
                            </>
                        )}
                    </Flex>
                    <Flex flex='0.5' id='address'>
                        <WalletAddress
                            address={wallet?.address}
                            network={props.network}
                        />
                    </Flex>
                </Flex>
                <Flex
                    direction='column'
                    justifyContent='center'
                    alignItems='center'
                >
                    <div id='registered-addresses'>
                        <Heading size='sm' color='blue.500'>
                            Address generati tramite BIS HUB
                        </Heading>
                    </div>
                    <Divider pt={2} />
                </Flex>
                <Flex flex='3' direction='column' overflow='scroll'>
                    <AddressList
                        addresses={props.addresses}
                        onAddressClick={addr =>
                            history.push(`/wallet/send/${addr}`)
                        }
                        network={props.network}
                        myAddress={wallet?.address}
                    />
                </Flex>
                <Flex h='40px' />
                <Footer>
                    <IconButton
                        id='send'
                        aria-label=''
                        icon={<PaperPlane fill='blue.500' />}
                        isRound
                        cursor='pointer'
                        position='absolute'
                        bottom='50px'
                        right='25px'
                        bg='white'
                        boxShadow='2px 2px 8px gray'
                        w='60px'
                        h='60px'
                        onClick={() => history.push('/wallet/send')}
                    />
                </Footer>
            </Flex>
            <Tour
                steps={steps}
                isOpen={isTourOpen}
                onRequestClose={handleTourClose}
            />
        </Container>
    );
};

const mapStateToProps = ({ wallet, addressbook, common }: any) => {
    return {
        wallet: wallet.wallet,
        loading: wallet.loading,
        addresses: addressbook.addresses,
        tourCompleted: common.guide.wallet,
        network: common.selectedNetwork,
    };
};

const mapDispatchToProps = (dispatch: any) => ({
    walletActions: bindActionCreators(wActions, dispatch),
    addressBookActions: bindActionCreators(abActions, dispatch),
    commonActions: {
        guideCompleted: (guideName: string) =>
            dispatch(guideCompleted(guideName)),
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Wallet);
